export default __webpack_public_path__ + "static/media/delete_placeholder.e414a93a.svg";